"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@angular/core");
const idm_filtering_controls_1 = require("@synisys/idm-filtering-controls");
const operators_1 = require("rxjs/operators");
const path_processing_helper_1 = require("../../../../shared/path-processing-helper");
const category_filter_item_1 = require("../../model/category-filter-item");
const lookup_selection_options_1 = require("../../model/lookup-selection-options");
let CategoryFilterComponent = class CategoryFilterComponent {
    constructor() {
        this.showLabel = true;
        this.viewMode = true;
        this.onLookupSelectionTypeChange = new core_1.EventEmitter();
        this.lookupSelectionOptions = lookup_selection_options_1.LookupSelectionOptions;
    }
    ngOnChanges(changes) {
        const filterItemChange = changes['filterItem'];
        const valueLoaderChange = changes['valueLoader'];
        if ((filterItemChange && !filterItemChange.isFirstChange()) ||
            (valueLoaderChange && !valueLoaderChange.isFirstChange())) {
            this.initValues();
        }
    }
    ngOnInit() {
        this.initValues();
    }
    initValues() {
        if (this.filterItem && this.valueLoader) {
            this.comboValues = this.valueLoader.getCategoryValues(this.filterItem.id)
                .pipe(operators_1.map((values) => {
                return path_processing_helper_1.initComboBoxOptions(values);
            }));
        }
    }
    lookupSelectionTypeChange(lookupSelectionType) {
        this.filterItem.lookupSelectionType = lookupSelectionType;
        this.filterItem.changeFilterOnLookupChange();
        this.onLookupSelectionTypeChange.emit(lookupSelectionType);
    }
};
__decorate([
    core_1.Input(),
    __metadata("design:type", category_filter_item_1.CategoryFilterItem)
], CategoryFilterComponent.prototype, "filterItem", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", idm_filtering_controls_1.ValueLoader)
], CategoryFilterComponent.prototype, "valueLoader", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Boolean)
], CategoryFilterComponent.prototype, "isDisabled", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Boolean)
], CategoryFilterComponent.prototype, "showLabel", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Boolean)
], CategoryFilterComponent.prototype, "viewMode", void 0);
__decorate([
    core_1.Output(),
    __metadata("design:type", core_1.EventEmitter)
], CategoryFilterComponent.prototype, "onLookupSelectionTypeChange", void 0);
CategoryFilterComponent = __decorate([
    core_1.Component({
        
        selector: 'sis-category-filter',
        template: require('./category-filter.component.html')
    }),
    __metadata("design:paramtypes", [])
], CategoryFilterComponent);
exports.CategoryFilterComponent = CategoryFilterComponent;
//# sourceMappingURL=category-filter.component.js.map